import {
  AnalyticsReportRoleScope,
  AnalyticsReportScope,
  AnalyticsReportTypeConfig,
  AnalyticsReportTypes,
} from '~/data/reports';

const HR_ROLES = [
  'HR_ADMIN',
  'HR_ADMIN_LIMITED',
  'HR_STAFF',
  'HR_PEOP_DEV',
  'HR_PEOP',
];

export const getRolesListReportType = (
  userRoles: string[],
  loggedInEmployeeId: number,
): AnalyticsReportTypeConfig => {
  const hasHRRole = userRoles.some((role) => HR_ROLES.includes(role));
  if (hasHRRole) {
    return {
      type: AnalyticsReportTypes.HR,
      employeeId: loggedInEmployeeId,
      role: AnalyticsReportRoleScope.Manager,
      scope: AnalyticsReportScope.All,
    };
  }
  if (userRoles.includes('MANAGER')) {
    return {
      type: AnalyticsReportTypes.Team,
      employeeId: loggedInEmployeeId,
      role: AnalyticsReportRoleScope.Manager,
      scope: AnalyticsReportScope.All,
    };
  }
  return {
    type: AnalyticsReportTypes.Company,
  };
};
